var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"C8dFP-q0Ej_X8qJYehdU8"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/frontend/0f56a676a876997fdc3161db54394d6d";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/browser';

let SENTRY_DSN = process.env.SENTRY_DSN_PRIVATE;

Sentry.init({
    dsn: 'https://c00145c8112043d8b1c661b99a51b37d@o1289708.ingest.sentry.io/6509318' || '',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.01,
    sampleRate: 1,
    enabled: process.env.NODE_ENV !== 'development',
    integrations: [new Sentry.BrowserTracing()],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
});
